import React from 'react';
import { InvestigationPhase } from './investigation-phase';
import { ApplicantIntakePhase } from './applicant-intake-phase';
import { ActiveCasePhase } from './active-case-phase/ActiveCasePhase';
import { SettlementPhase } from './settlement-phase';
import { CaseDetailsLawyer, PaymentError } from '@/interfaces';
import { auditService, GET_CASE_STEPS_STATUS } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { Spinner } from '@/components/common';
import { PhaseErrorContext } from '@/context';
import { getValidCaseId } from '@/utils';
interface CaseAdministrationProps {
	caseId: string;
	caseLawyerDetails: CaseDetailsLawyer | undefined;
	casesErrors: PaymentError[];
}

export const CaseAdministration: React.FC<CaseAdministrationProps> = ({
	caseId,
	casesErrors,
	// caseLawyerDetails,
}) => {
	const validCaseId = getValidCaseId(caseId);
	// const { isCaseReadOnly } = useContext(CaseContext);
	const { data: caseSteps, isFetching } = useQuery({
		queryKey: [GET_CASE_STEPS_STATUS, validCaseId],
		queryFn: () => auditService.getStepStatus(validCaseId as string),
		refetchOnWindowFocus: false,
		enabled: !!validCaseId,
	});
	const [currentOpenStep, setCurrentOpenStep] = React.useState<
		string[] | undefined
	>();
	const [isErrorPhaseMessage, setIsErrorPhaseMessage] =
		React.useState<boolean>(false);
	const [errorPhaseMessage, setErrorPhaseMessage] = React.useState<string>('');

	return (
		// <div
		// 	className={clsx(
		// 		'bg-white rounded-3xl p-8 border border-green-secondary',
		// 		{
		// 			'!bg-[#F4F4F4A3] !border !border-[#0D061614]': isCaseReadOnly,
		// 		}
		// 	)}
		// >
		<PhaseErrorContext.Provider
			value={{
				isErrorPhaseMessage,
				setIsErrorPhaseMessage,
				errorPhaseMessage,
				setErrorPhaseMessage,
			}}
		>
			{/* <Header updateInformation={caseSteps?.data.user_last_updated} /> */}
			<div className="">
				{caseSteps?.data.status.map((item) => (
					<React.Fragment key={'fase-' + item.fase_id}>
						{item.fase_name === 'Investigation' ? (
							<InvestigationPhase
							// caseDetails={caseLawyerDetails}
							// casePhase={item}
							// caseSteps={caseSteps?.data}
							// setCurrentOpenStep={setCurrentOpenStep}
							// currentOpenStep={currentOpenStep}
							/>
						) : item.fase_name === 'Applicant Intake' ? (
							<ApplicantIntakePhase
								// caseDetails={caseLawyerDetails}
								caseSteps={caseSteps?.data}
								casePhase={item}
								setCurrentOpenStep={setCurrentOpenStep}
								currentOpenStep={currentOpenStep}
							/>
						) : item.fase_name === 'Active Case' ? (
							<ActiveCasePhase
								casePhase={item}
								// caseDetails={caseLawyerDetails}
								// caseSteps={caseSteps?.data}
								setCurrentOpenStep={setCurrentOpenStep}
								currentOpenStep={currentOpenStep}
							/>
						) : item.fase_name === 'Settlement' ? (
							<SettlementPhase
								casePhase={item}
								caseSteps={caseSteps?.data}
								// caseDetails={caseLawyerDetails}
								setCurrentOpenStep={setCurrentOpenStep}
								currentOpenStep={currentOpenStep}
								casesErrors={casesErrors}
							/>
						) : null}
						<div className="h-12 w-[1px] bg-grey-20 mx-auto"></div>
					</React.Fragment>
				))}
			</div>
			{/* {!isFetching && <Notes caseId={caseId} />} */}
			{isFetching && (
				<div className="w-full flex justify-center">
					<Spinner type="loadingPage" />
				</div>
			)}
		</PhaseErrorContext.Provider>
		// {/* </div> */}
	);
};
